import React, { useState, useEffect } from 'react';
import { Paper, Fade, Box } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import { theme } from '../../../theme';
import ItemSubCategoryForm from '../../statefull/ManageItemSubCategory/ItemSubCategoryForm';
import ErrorHandler from '../Common/ErrorHandler';
import { categoryStyles } from '../../Styles/CategoryFormStyles';
import EditStoreOwnerModal from '../../statefull/EditStoreOwnerModal';
import { useTranslation } from 'react-i18next';

interface ItemSubCategoryModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  initialData?: {
    id: string;
    englishName: string;
    arabicName: string;
    addedBy: string;
  } | null;
  mode: 'add' | 'edit';
}

const ItemSubCategoryModal: React.FC<ItemSubCategoryModalProps> = ({
  open,
  setOpen,
  initialData,
  mode,
}) => {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(true);
  const [showForm, setShowForm] = useState(false);
  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);
    updateOnlineStatus();
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  useEffect(() => {
    if (open) {
      setTimeout(() => setShowForm(true), 500);
    } else {
      setShowForm(false);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleRetry = () => {
    if (navigator.onLine) {
      setIsOnline(true);
      setOpen(true);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <EditStoreOwnerModal
        open={open}
        onClose={handleClose}
        title={mode === 'add' ? t('itemSubCategory.form.title') : t('itemSubCategory.actions.edit')}
        // size="md"
      >
        {!isOnline ? (
          <Fade in={!isOnline}>
            <Paper elevation={3} sx={categoryStyles.errorCard}>
              <ErrorHandler
                type="network"
                message="You are currently offline. Please check your internet connection."
                onRetry={handleRetry}
              />
            </Paper>
          </Fade>
        ) : (
          showForm && (
            <Fade in={showForm} timeout={500}>
              <Box>
                <ItemSubCategoryForm
                  mode={mode}
                  onCancel={handleClose}
                  initialData={
                    mode === 'edit' && initialData
                      ? {
                          id: initialData.id,
                          englishName: initialData.englishName,
                          arabicName: initialData.arabicName,
                          addedBy: '',
                        }
                      : undefined
                  }
                />
              </Box>
            </Fade>
          )
        )}
      </EditStoreOwnerModal>
    </ThemeProvider>
  );
};

export default ItemSubCategoryModal;
